export enum FormType {
  Form = 'form',
  EditForm = 'editform',
}